import {Fragment, h} from "preact";
import Input from "../../../Input";
import s from "../beneficiaryForm.module.css";

const COUNTRIES_DATA = require("../../../../assets/general/ddi.json").data;

const ForeignerUserFields = (props) => {
    // Destructured props
    const {
        formValues,
        errors,
        handleChange
    } = props;

    // The variable name already says it all
    const countriesList = COUNTRIES_DATA.map(item => {
        return (
            <option
                key={item.code}
                value={item.code}
            >
                {item.name}
            </option>
        )
    });

    return (
        <Fragment>
            <div className={'w-full flex flex-col md:flex-row justify-between gap-[1.5rem]'}>
                <Input
                    type={"text"}
                    label={"Celular:"}
                    name={"phone"}
                    placeholder={"Seu número de celular"}
                    handleChange={handleChange}
                    value={formValues.phone}
                    error={errors.phone}
                    isRequired={true}
                />
                <fieldset className={"flex flex-col items-start justify-start gap-y-1 w-full"}>
                    <label htmlFor={"country-input"} className={s.inputLabel}>
                        País:&nbsp;
                        <span className={"text-sabin-red-default"}>
                            *
                        </span>
                    </label>
                    <select
                        id={"country-input"}
                        name={"country"}
                        onInput={handleChange}
                        value={formValues.country}
                        className={s.nationalityPicker + (
                            errors.country ? ` ${s.isInvalid}` : !errors.country && formValues.country ? ` ${s.isValid}` : ""
                        )}
                    >
                        <option value="">
                            Escolha o país
                        </option>
                        {countriesList}
                    </select>
                    {!!errors.country && (
                        <p className={s.errorMessage}>
                            {errors.country}
                        </p>
                    )}
                </fieldset>
            </div>
            <div className={'w-full flex flex-col md:flex-row justify-between gap-[1.5rem]'}>
                <Input
                    type={"text"}
                    label={"Código Postal:"}
                    name={"postalCode"}
                    placeholder={"Digite o seu código postal"}
                    handleChange={handleChange}
                    value={formValues.postalCode}
                    error={errors.postalCode}
                    isRequired={true}
                />
                <Input
                    type={"text"}
                    label={"Cidade:"}
                    name={"city"}
                    placeholder={"Sua cidade"}
                    handleChange={handleChange}
                    value={formValues.city}
                    error={errors.city}
                    isRequired={true}
                />
            </div>
            <div className={'w-full flex flex-col md:flex-row justify-between gap-[1.5rem]'}>
                <Input
                    type={"text"}
                    label={"Endereço:"}
                    name={"address"}
                    placeholder={"Insira o endereço"}
                    handleChange={handleChange}
                    value={formValues.address}
                    error={errors.address}
                    isRequired={true}
                />
                <Input
                    type={"text"}
                    label={"Número:"}
                    name={"number"}
                    placeholder={"Número da casa ou apartamento"}
                    handleChange={handleChange}
                    value={formValues.number}
                    error={errors.number}
                    isRequired={true}
                />
            </div>
        </Fragment>
    )
}

export default ForeignerUserFields;
